/**
 * The position in which sticky ads are anchored is calculated dinamically
 * and this STICKY_AD_TOP_GAP is a constant gap in pixels that is added to the
 * position.
 */
export const STICKY_AD_TOP_GAP = 20;

/**
 * Maximum widths for each device category. Used for ads, as well as UI behaviour
 * differentiation between mobile, tablet, desktop, etc.
 */
export const SMALL_DEVICE_WIDTH_MAX = 767;
export const MEDIUM_PORTRAIT_WIDTH_MAX = 959;
export const MEDIUM_DEVICE_WIDTH_MAX = 1024;
export const LARGE_DEVICE_WIDTH_MAX = 1200;

/**
 * In some special cases, we want to have different behaviours for iPad (or general tablet)
 * portrait vs landscape.
 */

export const TOUCH_DEVICE_HEADER_HEIGHT = 50;
export const DESKTOP_HEADER_HEIGHT = 70;
